import {
  deleteFolder,
  DeleteFolderParams,
} from '@dc-shared-web/hooks/api/folder/deleteFolder'

import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { useMutation, useQueryClient } from 'react-query'
import { FS } from '@dc-shared-web/lib/trackingConstants'
import { useFSTrackEvent } from '@dc-shared-web/hooks/api/analytic'
import { useToast } from '@dc-shared-web/components'

export const useDeleteFolder = (params?: {
  onSuccess?: () => void
  onError?: () => void
}) => {
  const apiClient = useSvcCrunchesContext()
  const { toast } = useToast()
  const { trackEvent } = useFSTrackEvent()
  const queryClient = useQueryClient()
  return useMutation(
    (mutationParams: DeleteFolderParams) =>
      deleteFolder(apiClient, mutationParams),
    {
      onSuccess: async (_, context) => {
        trackEvent(FS.FOLDER_DELETED)

        await Promise.allSettled([
          queryClient.invalidateQueries(['folder']),
          queryClient.invalidateQueries(['folders']),
          queryClient.invalidateQueries(['project']),
        ])

        toast({
          variant: 'success',
          description: `Folder "${context.name}" deleted.`,
        })
        params?.onSuccess?.()
      },
      onError: () => {
        toast({
          variant: 'error',
          title: 'Error deleting folder',
          description: 'If the issue persists, please contact support.',
        })
        params?.onError?.()
      },
    }
  )
}
